import React from 'react';

const FabricationErectionPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-primary-500 text-secondary-500 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold mb-4">
              Fabrication & Erection
            </h1>
            <p className="text-lg md:text-2xl text-secondary-100 max-w-3xl mx-auto">
              Expert fabrication and installation services for industrial
              applications
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Image Section - Left side on desktop, top on mobile */}
          <div className="lg:sticky lg:top-36 order-1 lg:order-1 animate-fade-in-left">
            <div className="rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img
                src="/fe.png"
                alt="Fabrication & Erection"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Content Section - Right side on desktop, bottom on mobile */}
          <div className="space-y-6 md:space-y-8 order-2 lg:order-2 animate-fade-in-right">
            {/* Piping Fabrication */}
            <div
              className="animate-slide-up"
              style={{ animationDelay: '0.1s' }}
            >
              <h2 className="text-2xl md:text-3xl font-bold text-primary-500 mb-4 md:mb-6">
                Fabrication & Erection of Piping
              </h2>
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-primary-500">
                <h4 className="font-semibold text-gray-800 mb-3">
                  Spool & Manifold
                </h4>
                <p className="text-sm md:text-base text-gray-700 mb-3">
                  <strong>Materials:</strong> CS (Carbon Steel), SS (Stainless
                  Steel), DSS (Duplex Stainless Steel), Alloy, etc.
                </p>
                <p className="text-sm md:text-base text-gray-700">
                  Expert fabrication and installation of piping systems for
                  various industrial applications.
                </p>
              </div>
            </div>

            {/* Steel Structural Fabrication */}
            <div
              className="animate-slide-up"
              style={{ animationDelay: '0.2s' }}
            >
              <h3 className="text-xl md:text-2xl font-bold text-primary-500 mb-4">
                Steel Structural Fabrication & Erection
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {[
                  'Industrial Shed',
                  'Coke Drum Chute',
                  'Platform',
                  'Handrail',
                  'Ladder',
                  'Pipe Support',
                  'Electrical & Instrument Steel Supports',
                  'Drive Supports',
                  'Insert & Embedded Plates',
                  'Height Restriction Gantry',
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-white p-3 rounded-lg shadow-sm border border-gray-200 animate-fade-in hover:shadow-md transition-shadow duration-200"
                    style={{ animationDelay: `${0.25 + index * 0.05}s` }}
                  >
                    <span className="text-sm md:text-base font-medium text-gray-800">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Plant Equipment Fabrication */}
            <div
              className="animate-slide-up"
              style={{ animationDelay: '0.3s' }}
            >
              <h3 className="text-xl md:text-2xl font-bold text-primary-500 mb-4">
                Plant Equipment Fabrication & Installation
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {[
                  'Transfer Pawl',
                  'Roller Apron',
                  'Roller Table',
                  'Furnace Duct Fabrication',
                  'Hopper',
                  'Inlet/Outlet Cones',
                  'SS Vessel Discharge Ring',
                  'Filter & Strainers',
                  'Chamber Panel',
                  'Rotary Feeder',
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-white p-3 rounded-lg shadow-sm border border-gray-200 animate-fade-in hover:shadow-md transition-shadow duration-200"
                    style={{ animationDelay: `${0.35 + index * 0.05}s` }}
                  >
                    <span className="text-sm md:text-base font-medium text-gray-800">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Sheet Metal Fabrication */}
            <div
              className="animate-slide-up"
              style={{ animationDelay: '0.4s' }}
            >
              <h3 className="text-xl md:text-2xl font-bold text-primary-500 mb-4">
                Sheet Metal Fabrication
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {[
                  'Gravity Spouting',
                  'Square to Round Spout',
                  'Elevator Casing Jacket',
                  'Coupling Guard',
                  'Universal Elbow',
                  'Pipe Bend',
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-white p-3 rounded-lg shadow-sm border border-gray-200 animate-fade-in hover:shadow-md transition-shadow duration-200"
                    style={{ animationDelay: `${0.45 + index * 0.05}s` }}
                  >
                    <span className="text-sm md:text-base font-medium text-gray-800">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Additional Services */}
            <div
              className="animate-slide-up"
              style={{ animationDelay: '0.5s' }}
            >
              <h3 className="text-xl md:text-2xl font-bold text-primary-500 mb-4">
                Additional Services
              </h3>
              <div className="space-y-3">
                {[
                  'Coded Qualified Welding',
                  'Security Panels, Grilles, Automatic Gates',
                  'Industrial Sheds, Car Parking, Boundary Fence',
                  'Any Tailor-made Fabrication and Erection Work According to Client Requirements',
                ].map((service, index) => (
                  <div
                    key={index}
                    className="flex items-start space-x-3 animate-fade-in hover:translate-x-2 transition-transform duration-200"
                    style={{ animationDelay: `${0.55 + index * 0.1}s` }}
                  >
                    <div className="flex-shrink-0 w-2 h-2 bg-primary-500 rounded-full mt-2"></div>
                    <p className="text-sm md:text-base text-gray-700">
                      {service}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Quality Standards */}
            <div
              className="animate-slide-up"
              style={{ animationDelay: '0.6s' }}
            >
              <h3 className="text-xl md:text-2xl font-bold text-primary-500 mb-4">
                Quality Standards
              </h3>
              <div className="flex flex-wrap gap-3">
                {[
                  'Coded Welding',
                  'Quality Control',
                  'Safety Standards',
                  'Custom Solutions',
                ].map((standard, index) => (
                  <span
                    key={index}
                    className="bg-primary-100 text-primary-500 px-4 py-2 rounded-full text-sm font-medium animate-fade-in hover:bg-primary-200 transition-colors duration-200"
                    style={{ animationDelay: `${0.65 + index * 0.1}s` }}
                  >
                    {standard}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-primary-500 text-secondary-500 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Need Custom Fabrication Solutions?
          </h2>
          <p className="text-lg md:text-xl text-secondary-100 mb-8 max-w-2xl mx-auto">
            Our experienced team delivers high-quality fabrication and erection
            services tailored to your specific requirements.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-secondary-500 text-primary-500 px-8 py-3 rounded-lg font-semibold hover:bg-secondary-100 transition-colors cursor-pointer"
            >
              Request Quote
            </a>
            <a
              href="/services"
              className="border-2 border-secondary-500 text-secondary-500 px-8 py-3 rounded-lg font-semibold hover:bg-secondary-500 hover:text-primary-500 transition-colors cursor-pointer"
            >
              View All Services
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FabricationErectionPage;
